























import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    Component,
    Vue,
    Prop,
    Watch
} from "vue-property-decorator";
import {
    componentDataType
} from "../types";
import GoogleMapsLoader from "google-maps";
import {
    GMAP_KEY
} from "../global";
import {
    ADD_ANIMATION
} from "../store/mutations.names";
@Component({
    name: "ProjectLoc",

})
export default class ProjectLoc extends Vue {
    @Prop() public compData!: any | null;
    @Prop() public last!: boolean;
    @Getter("isPreloaderLoaded") public isPreloaderFinished!: boolean;
    @Getter("mainTimeLineIsFinished") public mtlFinished!: boolean;
    @Mutation(ADD_ANIMATION) public[ADD_ANIMATION]: any;
    public show: boolean = false;
    public addedAnimation: boolean = false;

    @Watch("compData")
    handleCompDataChange(val: any, oldVal: any) {
        this.projectGmap(val);
    }

    public projectGmap(compData = this.compData) {
        if (compData == null || !compData) {
            return null;
        }
        GoogleMapsLoader.KEY = GMAP_KEY;
        GoogleMapsLoader.VERSION = "3.36";

        GoogleMapsLoader.load((google: any) => {
            const latLong = new google.maps.LatLng(
                parseFloat(compData!.latitude),
                parseFloat(compData!.longitude)
            );
            const mapOptions = {
                zoom: 19,
                center: latLong,
                styles: [{
                        "featureType": "all",
                        "elementType": "labels.text.fill",
                        "stylers": [{
                                "saturation": 36
                            },
                            {
                                "color": "#333333"
                            },
                            {
                                "lightness": 40
                            }
                        ]
                    },
                    {
                        "featureType": "all",
                        "elementType": "labels.text.stroke",
                        "stylers": [{
                                "visibility": "on"
                            },
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 16
                            }
                        ]
                    },
                    {
                        "featureType": "all",
                        "elementType": "labels.icon",
                        "stylers": [{
                            "visibility": "simplified"
                        }]
                    },
                    {
                        "featureType": "administrative",
                        "elementType": "all",
                        "stylers": [{
                            "visibility": "simplified"
                        }]
                    },
                    {
                        "featureType": "administrative",
                        "elementType": "geometry.fill",
                        "stylers": [{
                                "color": "#fefefe"
                            },
                            {
                                "lightness": 20
                            }
                        ]
                    },
                    {
                        "featureType": "administrative",
                        "elementType": "geometry.stroke",
                        "stylers": [{
                                "color": "#fefefe"
                            },
                            {
                                "lightness": 17
                            },
                            {
                                "weight": 1.2
                            }
                        ]
                    },
                    {
                        "featureType": "landscape",
                        "elementType": "geometry",
                        "stylers": [{
                                "lightness": 20
                            },
                            {
                                "color": "#ececec"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape.man_made",
                        "elementType": "all",
                        "stylers": [{
                                "visibility": "on"
                            },
                            {
                                "color": "#e8e8e3"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape.man_made",
                        "elementType": "geometry.fill",
                        "stylers": [{
                                "visibility": "on"
                            },
                            {
                                "color": "#e8e8e3"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape.man_made",
                        "elementType": "geometry.stroke",
                        "stylers": [{
                                "visibility": "on"
                            },
                            {
                                "color": "#dcdcd2"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape.natural",
                        "elementType": "all",
                        "stylers": [{
                                "visibility": "on"
                            },
                            {
                                "color": "#dcdcd2"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "all",
                        "stylers": [{
                            "visibility": "on"
                        }]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "geometry",
                        "stylers": [{
                                "lightness": 21
                            },
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "geometry.fill",
                        "stylers": [{
                                "visibility": "on"
                            },
                            {
                                "color": "#dcdcd2"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "labels.text.fill",
                        "stylers": [{
                            "color": "#303030"
                        }]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "labels.icon",
                        "stylers": [{
                            "saturation": "-100"
                        }]
                    },
                    {
                        "featureType": "poi.attraction",
                        "elementType": "all",
                        "stylers": [{
                            "visibility": "on"
                        }]
                    },
                    {
                        "featureType": "poi.business",
                        "elementType": "all",
                        "stylers": [{
                            "visibility": "off"
                        }]
                    },

                    {
                        "featureType": "poi.government",
                        "elementType": "all",
                        "stylers": [{
                            "visibility": "off"
                        }]
                    },

                    {
                        "featureType": "poi.medical",
                        "elementType": "all",
                        "stylers": [{
                            "visibility": "on"
                        }]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "all",
                        "stylers": [{
                            "visibility": "on"
                        }]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "geometry",
                        "stylers": [{
                                "color": "#dedede"
                            },
                            {
                                "lightness": 21
                            }
                        ]
                    },
                    {
                        "featureType": "poi.place_of_worship",
                        "elementType": "all",
                        "stylers": [{
                            "visibility": "on"
                        }]
                    },
                    {
                        "featureType": "poi.school",
                        "elementType": "all",
                        "stylers": [{
                            "visibility": "on"
                        }]
                    },

                    {
                        "featureType": "poi.school",
                        "elementType": "geometry.stroke",
                        "stylers": [{
                                "lightness": "-61"
                            },
                            {
                                "gamma": "0.00"
                            },
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "poi.sports_complex",
                        "elementType": "all",
                        "stylers": [{
                            "visibility": "off"
                        }]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.fill",
                        "stylers": [{
                                "color": "#f7f5f0"
                            },
                            {
                                "lightness": 17
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.stroke",
                        "stylers": [{
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 29
                            },
                            {
                                "weight": 0.2
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "geometry",
                        "stylers": [{
                                "color": "#f7f5f0"
                            },
                            {
                                "lightness": 18
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "geometry",
                        "stylers": [{
                                "color": "#f7f5f0"
                            },
                            {
                                "lightness": 16
                            }
                        ]
                    },
                    {
                        "featureType": "transit",
                        "elementType": "geometry",
                        "stylers": [{
                                "color": "#f2f2f2"
                            },
                            {
                                "lightness": 19
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "geometry",
                        "stylers": [{
                                "color": "#dce8e5"
                            },
                            {
                                "lightness": 17
                            }
                        ]
                    }
                ]

            };

            const prmap = new google.maps.Map(
                this.$refs.projectmap as HTMLElement,
                mapOptions as any
            );
            let iconBase = 'http://rdldev.codesign.com.bd/api/v2/images/ZdQe1oUWj5mmFPkPS-VLETQh7Ro=/119/original/';
            const marker = new google.maps.Marker({
                position: latLong,
                icon: iconBase + 'gmap.png'
            });
            marker.setMap(prmap);
        });
    }
    public mounted(): void {
        this.$nextTick(() => {
            this.projectGmap();
        });
        this.show = true;
    }

}
